import { textBlockCss } from '@/constants/textBlockStyles';
import type { RichTextItem } from '@/types/ads';

import { stickers } from '@/constants/richMessage';

export default function RichMessagePreview({ items, fontScale = 1, wrap = false }: { items: RichTextItem[]; fontScale?: number; wrap?: boolean }) {
  return <span className={`inline-flex items-center gap-[0.35em] align-middle ${wrap ? 'max-w-full flex-wrap whitespace-pre-wrap [overflow-wrap:anywhere]' : 'whitespace-nowrap'}`}>
    <style>{`
      @keyframes rich-bounce { 50% { transform: translateY(-12%); } }
      @keyframes rich-pulse { 50% { transform: scale(.8); } }
      @keyframes rich-wiggle { 25% { transform: rotate(-12deg); } 75% { transform: rotate(12deg); } }
      @media (prefers-reduced-motion: reduce) { .rich-sticker { animation: none !important; } }
    `}</style>
    {items.map((item, index) => item.kind === 'IMAGE'
      ? <img key={index} src={item.imageUrl || undefined} alt={item.alt} className="inline-block h-[1.5em] w-[1.8em] object-contain" />
      : item.kind === 'STICKER'
        ? <span key={index} className="rich-sticker inline-block" style={{ animation: `${stickers[item.sticker ?? '']?.motion ?? 'rich-pulse'} 1.2s ease-in-out infinite` }}>{stickers[item.sticker ?? '']?.emoji}</span>
        : <span key={index} className={wrap ? 'min-w-0 max-w-full' : undefined} style={item.kind === 'TEXT' ? textBlockCss(item.style?.fontSize ? { ...item.style, fontSize: item.style.fontSize * fontScale } : item.style) : undefined}>{item.text}</span>)}
  </span>;
}
